import { Component } from 'react'
import Statics from 'objects/common/Statics'
import { RequestAula } from "objects/requests"

/**
 * Clase donde se guardan las peticiones que se van a usar
 */
export default class Requests extends Component {

    /**
     * Hace la petición para crear las aulas
     * 
     * @param {Int} id 
     * @param {Function} getValues 
     * @param {Function} callbackOk 
     * @param {Function} callbackError 
     */
    createAula(getValues, callbackOk = () => {}, callbackError = () => {}) {
        const formData = new FormData()
        formData.append("denominacion",       getValues("denominacion").toUpperCase())
        formData.append("capacidad",            getValues("capacidad"))
        new RequestAula().create(formData, callbackOk, callbackError)
    }
}
